// extracted by mini-css-extract-plugin
module.exports = {"row":"table-row_row__svnPx"};